import enMessages from './en.json';
import roMessages from './ro.json';

export const messages = {
  en: enMessages,
  ro: roMessages,
};

export const defaultLocale = 'ro';
export const supportedLocales = ['en', 'ro'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];
